import React from "react";
import ReactGA from "react-ga4";
import "./ProductListCard.css";

const ProductListCard = ({
  product,
  showProdStatus,
  showPrice,
  onClick,
  isMobile,
  priority = false,
}) => {
  const handleCardClick = () => {
    const IsEmployee = localStorage.getItem("IsEmployee");

    if (IsEmployee === "false") {
      ReactGA.event({
        category: "Product",
        action: "clicked on product card",
        label: product.DesignNo, // optional
        value: product.ProductID, // optional, must be a number
        nonInteraction: false, // optional, true/false
        transport: "xhr", // optional, beacon/xhr/image
      });
    }

    sessionStorage.setItem("ProductID", product.ProductID);

    if (onClick) {
      onClick(product);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleCardClick();
    }
  };

  const ribbonText =
    product.Tag1 && product.Tag1.trim() !== "" ? product.Tag1 : null;
  const badgeText =
    product.Tag2 && product.Tag2.trim() !== "" ? product.Tag2 : null;

  const hasDeal =
    product.DealRate &&
    product.DealRate > 0 &&
    product.DealRate < product.SalesRate;

  return (
    <div
      className="product-tile"
      role="button"
      tabIndex={0}
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      style={{
        contentVisibility: "auto",
        containIntrinsicSize: isMobile ? "0 420px" : "0 480px",
      }}
    >
      <div className="product-tile__image-wrap">
        {ribbonText && <span className="product-tile__ribbon">{ribbonText}</span>}
        <img
          className="product-tile__image"
          alt={product.ProductName}
          src={product.ImageUrl}
          loading={priority ? "eager" : "lazy"}
          fetchPriority={priority ? "high" : "auto"}
          decoding="async"
        />
        {product.NoOfColor && product.NoOfColor > 1 ? (
          <span className="product-tile__variant-chip">
            {product.NoOfColor} colors
          </span>
        ) : null}
      </div>

      <div className="product-tile__body">
        {(showProdStatus || badgeText) && (
          <div className="product-tile__badges">
            {showProdStatus && (
              <span
                className={`product-tile__status ${
                  product.Status === "Available"
                    ? "product-tile__status--available"
                    : "product-tile__status--out"
                }`}
              >
                {product.Status}
              </span>
            )}
            {badgeText && (
              <span className="product-tile__tag2">● {badgeText}</span>
            )}
          </div>
        )}

        <h4 className="product-tile__name" title={product.ProductName}>
          {isMobile ? product.DesignNo : product.ProductName}
        </h4>

        {!isMobile && (
          <p className="product-tile__meta">
            Design No. {product.DesignNo}
            <br />
            Box: {product.QtyInBox} {product.Unit}(s) · Colors:{" "}
            {product.NoOfColor}
          </p>
        )}

        <div className="product-tile__price">
          {showPrice ? (
            hasDeal ? (
              <>
                <span className="product-tile__price-strike">
                  ₹{product.SalesRate.toFixed(2)}
                </span>
                <span className="product-tile__price-deal">
                  ₹{product.DealRate.toFixed(2)}
                </span>
              </>
            ) : (
              <span className="product-tile__price-regular">
                ₹{product.SalesRate?.toFixed(2)}
              </span>
            )
          ) : (
            <span className="product-tile__price-locked">
              Login to view price
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProductListCard);
